export default "__VITE_ASSET__BokAKAO$__"